// extracted by mini-css-extract-plugin
export default {"analyticsDashboard":"OCBAfm7Wrcle6pV1EFi9"};